import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { REAPPRO_CATEGORY_PREVIEW_KEY } from './reapproCategoryPreview.hooks'
import {
  exportReapproStockMinimumToXlsx,
  importReapproStockMinimumFromXlsx,
  upsertStoreProductReapproParam,
} from '../mutations/storeProductReapproParams.mutations'
import { fetchStoreProductReapproParams } from '../queries/storeProductReapproParams.queries'

export const useStoreProductReapproParams = (storeId: number, reapproCategoryId: number) =>
  useQuery({
    queryKey: ['storeProductReapproParams', storeId, reapproCategoryId],
    queryFn: () => fetchStoreProductReapproParams(storeId, reapproCategoryId),
  })

export const useUpsertStoreProductReapproParam = (storeId: number, reapproCategoryId: number) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: upsertStoreProductReapproParam,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['storeProductReapproParams', storeId, reapproCategoryId],
      })
      void queryClient.invalidateQueries({
        queryKey: [REAPPRO_CATEGORY_PREVIEW_KEY, storeId, reapproCategoryId],
      })
    },
  })
}

export const useExportReapproStockMinimum = () =>
  useMutation({ mutationFn: exportReapproStockMinimumToXlsx })

export const useImportReapproStockMinimum = () =>
  useMutation({ mutationFn: importReapproStockMinimumFromXlsx })
